import {translations} from './translations';

export const ADMIN_LANG = translations.fi;
export const DEFAULT_LANG = 'fi'
export const AVAILABLE_LANGUAGES = ['fi', 'en', 'sv'];

export const [VIEW_USER, ADD_USER, CHANGE_USER, DELETE_USER] = [
    'scope.admin.view_user',
    'scope.admin.add_user',
    'scope.admin.change_user',
    'scope.admin.delete_user'
];

export const [STATUS_PUBLISHED, STATUS_DRAFT, STATUS_ARCHIVED, STATUS_NOT_IN_USE] =
    [1, 2, 3, 4];

export const [
    UPLOAD_PENDING,
    UPLOAD_IN_PROGRESS,
    UPLOAD_COMPLETED,
    UPLOAD_FAILED
] = ['pending', 'in_progress', 'completed', 'failed'];

export const FEATURE_PDF_UPLOAD = true;
export const FEATURE_NOTIFICATIONS = true;
export const FEATURE_AI_TRANSLATION = true;